<template>
  <div>
    <Loader :messageSelector="messageSelector" :overlay="overlay" />

    <v-form ref="form" v-model="valid" :disabled="readonly">
      <fieldset>
        <legend class="text-h6 text-sm-h5">Informations ré-inscription</legend>
        <div v-if="isRadiePlus5ans" style="text-align: Left">
          <p>
            Veuillez-vous référer aux liens suivants pour connaître les exigences relatives aux documents à téléverser selon votre situation
            :
          </p>
          <ol>
            <li>
              <a
                href="https://www1.otstcfq.org/exercer-au-quebec/exercer-au-quebec/admission-et-inscription/permis-exercice-ts-et-tcf/diplome-travail-social-quebec/#1613951397810-2b0ef8bf-2c99"
                target="_blank"
                >Réinscription à titre de travailleur social + de 5 ans</a
              >
            </li>
            <li>
              <a
                href="https://www1.otstcfq.org/exercer-au-quebec/exercer-au-quebec/admission-et-inscription/permis-exercice-ts-et-tcf/diplome-therapie-conjugale-quebec/#1614200141801-84ac2755-1af9"
                target="_blank"
                >Réinscription à titre de thérapeute conjugal et famillial + de 5 ans</a
              >
            </li>
          </ol>
        </div>
        <p v-else style="text-align: Left">
          Cette section s'adresse aux personnes ayant été membres de l'Ordre auparavant à titre de travailleur social ou thérapeute conjugal
          et familial, mais ayant été absents du tableau de l'Ordre durant plus de 5 ans. Si ce n'est pas votre cas, faites suivant.<br />
        </p>
      </fieldset>
      <div v-if="isRadiePlus5ans">
        <fieldset>
          <legend class="text-h6 text-sm-h5" style="font-weight: bold; text-align: center">
            Documents relatifs à votre expérience de travail et activités de bénévolat
          </legend>
          <v-row>
            <v-col class="legalSection" cols="12" md="6">
              <Attachment
                ref="equivCurriculum"
                file-prefix="form_equiv_curriculum"
                @completeEvent="saveNextAttachment"
                @refreshEvent="validateForm(true)"
              ></Attachment>
            </v-col>
            <v-col class="legalSection" cols="12" md="6">
              <Attachment
                ref="equivAttestationEmployeur"
                file-prefix="form_equiv_attestation_employeur"
                @completeEvent="saveNextAttachment"
                @refreshEvent="validateForm(true)"
              ></Attachment>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="legalSection" cols="12" md="6">
              <Attachment
                :minRequired="0"
                ref="equivAttestationBenevole"
                file-prefix="form_equiv_attestation_benevole"
                @completeEvent="saveNextAttachment"
                @refreshEvent="validateForm(true)"
              ></Attachment>
            </v-col>
            <v-col class="legalSection" cols="12" md="6" style="text-align: center"> </v-col>
          </v-row>
        </fieldset>
      </div>
    </v-form>
    <div class="text-center mt-6 d-flex justify-space-between">
      <v-btn color="primary" @click="back()">Retour</v-btn>
      <v-btn :disabled="!canSubmit || !valid" color="secondary" @click="saveAndContinueLater()">Enregistrer et terminer plus tard </v-btn>
      <v-btn :disabled="!canSubmit || !valid" color="primary" @click="saveAndContinue()">Suivant</v-btn>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex"
import Attachment from "../attachments/Attachment"
import Loader from "../Loader"
import NavigationPageFormulaireMixin from "@/mixins/navigationPageFormulaireMixin"
import PageReadonlyFormulaireAdmissionMixin from "@/mixins/pageReadonlyFormulaireAdmissionMixin"
import AttachementFormulaireMixin from "@/mixins/attachementFormulaireMixin"

export default {
  mixins: [NavigationPageFormulaireMixin, PageReadonlyFormulaireAdmissionMixin, AttachementFormulaireMixin],
  props: {
    routeName: {
      type: String,
      default: "",
    },
  },
  components: {
    Attachment: Attachment,
    Loader: Loader,
  },
  data() {
    return {
      overlay: false,
      messageSelector: "",
      valid: true,
      rules: {
        TypeFormations: [(v) => (!!v && v.length != 0) || "Le diplôme est requis"],
        AutreFormation: [(v) => (!!v && v.length != 0) || "La description de la formation est obligatoire"],
      },
      menuDateObtention: [],
      menuDateDeFinDeProgramme: [],
    }
  },
  computed: {
    ...mapGetters({
      demandeAdmissionId: "DemandeAdmission/GET_DEMANDEADMISSIONID",
      demandeAdmissionPpId: "DemandeAdmission/GET_CONTACTID",
      getAutorisation: "AutorisationDePratique/GET_AUTORISATIONSDEPRATIQUE",
    }),
    isRadiePlus5ans: function () {

      const isMoinsDe5Ans = (date) => {
        // One year Time in ms (milliseconds)
        const one_year_in_ms = 1000 * 60 * 60 * 24 * 365

        return (new Date().getTime() - new Date(date).getTime()) / one_year_in_ms < 5
      }

      return (
        this.getAutorisation &&
        this.getAutorisation.some(
          (autorisation) =>
            autorisation.demandeAdmission === this.demandeAdmissionId &&
            autorisation.statut != null &&
            (autorisation.statut.id === this.$catalogues.statutAutorisationDePatique.retire ||
              autorisation.statut.id === this.$catalogues.statutAutorisationDePatique.inactif ||
              autorisation.statut.id === this.$catalogues.statutAutorisationDePatique.radie) &&
            autorisation.dateDeFin != null &&
            !isMoinsDe5Ans(autorisation.dateDeFin)
        )
      )
    },
    canSubmit: function () {
      let result = true

      if (this.isRadiePlus5ans && this.curriculumCount < 1) {
        result = false
      }

      return result
    },
  },
  async created() {
    await this.fetchItems()
  },
  watch: {
    menuDateObtention(val) {
      let self = this
      val.forEach((picker, index) => {
        if (picker) {
          picker && setTimeout(() => (self.$refs.pickerStart[index].activePicker = "YEAR"))
        }
      })
    },
    menuDateDeFinDeProgramme(val) {
      let self = this
      val.forEach((picker, index) => {
        if (picker) {
          picker && setTimeout(() => (self.$refs.pickerEnd[index].activePicker = "YEAR"))
        }
      })
    },
  },
  methods: {
    ...mapActions({
      getCatalogue: "Catalogue/getCatalogue",
      getDocumentsByDemandeAdmissionId: "Documents/getDocumentsByDemandeAdmissionId",
      getAutorisationDePratiqueByDemandeAdmissionId: "AutorisationDePratique/getAutorisationDePratiqueByDemandeAdmissionId",
    }),
    async fetchItems() {
      try {
        this.messageSelector = "Loading"
        this.overlay = true

        // Catalogue Categorie Formation
        await this.getCatalogue(1526)

        if (this.demandeAdmissionId) {
          await this.getDocumentsByDemandeAdmissionId(this.demandeAdmissionId)
          await this.getAutorisationDePratiqueByDemandeAdmissionId(this.demandeAdmissionId)
        }

        // Liste les uploads de fichiers
        this.refsUpload = [
          () => this.$refs.equivCurriculum,
          () => this.$refs.equivAttestationEmployeur,
          () => this.$refs.equivAttestationBenevole,
        ]

        this.overlay = false
      } catch (erreur) {
        console.log(erreur)
      }
    },
    save() {
      this.messageSelector = "Save"
      this.overlay = true

      this.$refs.form.validate()
      if (this.valid && this.canSubmit) {
        this.saveAttachments("demandeAdmission", this.demandeAdmissionId, () => {
          this.overlay = false
          this.redirect()
        })
      }
    },
    validateForm(resetValidation = false) {
      this.valid = this.$refs.form?.validate() || false

      if (resetValidation) {
        this.$refs.form?.resetValidation()
      }
    },
  },
}
</script>

<style></style>